var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),_c('Search'),(this.$store.state.validos.length > 0)?[_c('Footer')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }